<template>
    <div class="company-manage-page">
        <el-card class="page-card">
            <template #header>
                <div class="card-header">公司管理</div>
            </template>

            <div class="card-body">
                <el-row type="flex" justify="space-between" align="middle" class="toolbar">
                    <el-col>
                        <el-button v-if="hasAddPermission" type="primary" icon="el-icon-plus" @click="handleCreate">新建公司</el-button>
                    </el-col>
                    <el-col>
                        <el-input size="small" placeholder="搜索公司" v-model="filters.keyword" clearable @clear="fetchData"
                            @keyup.enter.native="fetchData" style="width:220px">
                            <i slot="suffix" class="el-input__icon el-icon-search" @click="fetchData"></i>
                        </el-input>
                    </el-col>
                </el-row>

                <el-table :data="pageData" stripe border style="width: 100%; margin-top: 12px" row-key="id"
                    :loading="loading">
                    <el-table-column prop="company_id" label="公司ID" width="80" align="center" header-align="center" />
                    <el-table-column prop="company_name" label="公司名称" align="center" header-align="center">
                        <template v-slot="{ row }">
                            {{ row.company_name || row.name }}
                        </template>
                    </el-table-column>

                    <el-table-column prop="created_at" label="创建时间" align="center"
                        header-align="center"></el-table-column>
                    <el-table-column label="操作" fixed="right" width="500" align="center" header-align="center">
                        <template slot-scope="scope">
                            <el-button v-if="hasEnablePermission" size="mini" type="primary" @click="handleEnable(scope.row)">开通</el-button>
                            <el-button v-if="hasEditPermission" size="mini" @click="handleEdit(scope.row)">编辑</el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <div class="pagination-wrap">
                    <el-pagination layout="total, sizes, prev, pager, next, jumper" :total="total"
                        :page-sizes="[10, 15, 20, 50]" :page-size.sync="pager.pageSize" :current-page.sync="pager.page"
                        @size-change="handleSizeChange" @current-change="handleCurrentChange" />
                </div>
            </div>
        </el-card>

        <!-- 详情对话框 -->
        <el-dialog :visible.sync="detailDialog" title="公司详情" width="600px">
            <div v-if="detailRow" class="detail-content">
                <p><strong>公司ID：</strong> {{ detailRow.company_id || detailRow.id }}</p>
                <p><strong>公司名称：</strong> {{ detailRow.company_name || detailRow.name }}</p>
                <p><strong>创建时间：</strong> {{ detailRow.created_at }}</p>
                <p><strong>状态：</strong> {{ detailRow.status || (detailRow.raw && detailRow.raw.status) }}</p>
                <el-divider />

            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="detailDialog = false">关闭</el-button>
            </span>
        </el-dialog>

        <!-- 新建/编辑公司对话框 -->
        <el-dialog :visible.sync="companyDialog" :title="isEditing ? '编辑公司' : '新建公司'" width="600px">
            <el-form :model="companyForm" :rules="companyRules" ref="companyForm" label-width="100px">
                <el-form-item label="公司ID" prop="company_id">
                    <!-- 公司ID 由系统生成，不允许在新建或编辑时手动修改 -->
                    <el-input v-model="companyForm.company_id" placeholder="系统自动生成，不允许修改" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="公司名称" prop="company_name">
                    <el-input v-model="companyForm.company_name" placeholder="请输入公司名称"></el-input>
                </el-form-item>
                <el-form-item label="状态" prop="status">
                    <el-select v-model="companyForm.status" placeholder="选择状态" style="width:200px">
                        <el-option label="删除" :value="0"></el-option>
                        <el-option label="正常" :value="1"></el-option>
                        <el-option label="冻结" :value="2"></el-option>
                    </el-select>
                </el-form-item>
                <!-- 已移除：状态、Logo、排序（现在仅填写公司名称） -->
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="companyDialog = false">取消</el-button>
                <el-button type="primary" :loading="formLoading" @click="submitCompany">保存</el-button>
            </span>
        </el-dialog>

        <!-- 产品选择/开通对话框 -->
        <el-dialog :visible.sync="productDialog" title="开通产品" width="520px">
            <div v-if="productList && productList.length">
                <el-checkbox-group v-model="selectedProducts">
                    <el-checkbox v-for="p in productList" :label="p.id" :key="p.id">{{ p.name }} <small
                            style="color:#999">({{
                                p.mark }})</small></el-checkbox>
                </el-checkbox-group>
                <div style="margin-top:12px">
                    <el-tag v-for="p in productList" :key="p.id" style="margin-right:6px" type="info">{{ p.name
                        }}</el-tag>
                </div>
            </div>
            <div v-else class="empty" style="text-align:center; padding:20px">未获取到产品数据</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="productDialog = false">取消</el-button>
                <el-button type="primary" :loading="enablingLoading" @click="confirmEnable">确认开通</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { companyList, addcompany, companyDetail, addcompanyProduct } from '@/api/api'
import { hasPermission } from '@/utils/auth'
import dayjs from 'dayjs';
export default {
    name: 'CompanyManage',
    data() {
        return {
            loading: false,
            list: [],
            detailDialog: false,
            detailRow: null,
            // 新建/编辑弹框
            companyDialog: false,
            isEditing: false,
            formLoading: false,
            // 产品弹框相关
            productDialog: false,
            productList: [],
            selectedProducts: [],
            enablingRow: null,
            enablingLoading: false,
            companyForm: {
                id: null,
                company_id: '',
                company_name: '',
                // 0=删除,1=正常,2=冻结
                status: 1
            },
            companyRules: {
                company_name: [{ required: true, message: '请填写公司名称', trigger: 'blur' }]
            },
            serverSide: false,
            pager: {
                page: 1,
                pageSize: 15
            },
            total: 4,
            filters: {
                keyword: ''
            }
        }
    },
    computed: {
        pageData() {
            // 如果后端返回了分页（total 字段），list 通常是当前页数据，直接返回
            if (this.serverSide) return this.list
            const start = (this.pager.page - 1) * this.pager.pageSize
            return this.list.slice(start, start + this.pager.pageSize)
        },
        // 按钮权限检查
        hasAddPermission() {
            return hasPermission('adds')
        },
        hasEditPermission() {
            return hasPermission('edit')
        },
        hasEnablePermission() {
            return hasPermission('activate')
        }
    },
    mounted() {
        this.fetchData()
    },
    methods: {
        async fetchData() {
            this.loading = true
            try {
                const params = {
                    page: this.pager.page,
                    per_page: this.pager.pageSize,
                    keyword: this.filters.keyword || undefined
                }
                const res = await companyList(params)

                // 支持多种返回结构，优先处理后端分页格式（如你提供的示例）
                // 典型示例结构：{ current_page, data: [...], per_page, total }
                if (res) {
                    // 如果 res.data 是数组并且 res.total 存在，按分页处理
                    if (Array.isArray(res.data) && (typeof res.total === 'number' || typeof res.total === 'string')) {
                        this.serverSide = true
                        // map 后端字段到组件字段
                        this.list = res.data.map(item => ({
                            id: item.id,
                            company_id: item.company_id,
                            company_name: item.company_name || item.name || '',
                            created_at: item.created_at,

                        }))
                        this.total = Number(res.total) || this.list.length
                        // 同步服务端分页信息到 pager（避免丢失当前页信息）
                        this.pager.page = Number(res.current_page) || this.pager.page
                        this.pager.pageSize = Number(res.per_page) || this.pager.pageSize
                    } else if (res.data && (res.data.list || res.data.items)) {
                        // 处理 data.list 结构
                        const payload = res.data.list || res.data.items
                        this.serverSide = true
                        this.list = payload.map(item => ({
                            id: item.id,
                            company_id: item.company_id,
                            company_name: item.company_name || item.name || '',
                            created_at: item.created_at,

                        }))
                        this.total = res.data.total || res.data.count || this.list.length
                    } else if (Array.isArray(res)) {
                        // 如果直接返回数组
                        this.serverSide = false
                        this.list = res.map(item => ({
                            id: item.id,
                            company_id: item.company_id,
                            company_name: item.company_name || item.name || '',
                            created_at: item.created_at,
                        }))
                        this.total = res.length
                    } else {
                        // 未知结构，尝试解析常见字段
                        if (Array.isArray(res.data)) {
                            this.serverSide = true
                            this.list = res.data.map(item => ({
                                id: item.id,
                                company_id: item.company_id,
                                company_name: item.company_name || item.name || '',
                                created_at: item.created_at,
                            }))
                            this.total = res.total || res.count || this.list.length
                        } else if (Array.isArray(res.data && res.data.data)) {
                            // 保护性解析
                            this.serverSide = true
                            this.list = (res.data && res.data.data).map(item => ({
                                id: item.id,
                                company_id: item.company_id,
                                company_name: item.company_name || item.name || '',
                                created_at: item.created_at,
                            }))
                            this.total = res.data.total || res.total || this.list.length
                        }
                    }
                    // 列表已在映射阶段处理 created_at 的格式化，这里不再重复处理

                }
            } catch (err) {
                console.error('companyList error', err)
                this.$message.error(err.message || '获取公司列表失败')
            } finally {
                this.loading = false
            }
        },
        handleCreate() {
            // 打开新建公司弹框
            this.isEditing = false
            this.resetCompanyForm()
            this.companyDialog = true
        },
        handleImport() {
            this.$message({ type: 'info', message: '批量导入（示例）' })
        },
        handleEdit(row) {
            // 打开编辑弹框，填充表单
            this.isEditing = true
            this.companyForm = {
                id: row.id || null,
                company_id: row.company_id || row.id || '',
                company_name: row.company_name || row.name || '',
                // 尝试从 raw.status 或字符串状态映射获取数值
                status: (row.raw && typeof row.raw.status !== 'undefined') ? row.raw.status : (typeof row.status === 'number' ? row.status : (row.status === '显示' ? 1 : (row.status === '隐藏' ? 0 : 1)))
            }
            this.companyDialog = true
        },
        handleDelete(row) {
            this.$confirm(`确定删除 ${row.company_name || row.name} 吗？`, '删除确认', { type: 'warning' }).then(() => {
                this.list = this.list.filter(i => i.id !== row.id)
                this.total = this.list.length
                this.$message({ type: 'success', message: '删除成功' })
            }).catch(() => { })
        },
        handleDetails(row) {
            // 打开详情对话框
            this.detailRow = row
            this.detailDialog = true
        },
        // 判断是否已开通：支持数字状态、文本状态或 raw.status
        isEnabled(row) {
            if (!row) return false
            const s = (row.status !== undefined && row.status !== null) ? row.status : (row.raw && row.raw.status)
            // 规范判断：数字 1 或 字符串 '1' 或 常见文本 '显示'/'正常' 视为已开通
            if (s === 1 || s === '1') return true
            if (typeof s === 'string') {
                const low = s.toLowerCase()
                return low === '显示' || low === '正常' || low === 'enabled' || low === 'active'
            }
            return false
        },
        handleEnable(row) {
            // 点击开通时请求产品详情并弹出选择框，用户可勾选要开通的产品
            this.$confirm(`开始请求 ${row.company_name || row.name || ''} 的产品信息吗？`, '请求产品详情', { type: 'info' }).then(async () => {
                try {
                    const params = { company_id: row.company_id || row.id }
                    const res = await companyDetail(params)
                    const list = (res && res.data) ? res.data : (Array.isArray(res) ? res : (res && res.data && res.data.data) ? res.data.data : [])
                    this.productList = list || []
                    // 默认不选中任何产品，用户可手动选择
                    this.selectedProducts = []
                    // 记录当前操作的行，确认时会使用
                    this.enablingRow = row
                    // 在行里保存原始的 productInfo 以便前端查看
                    if (res) this.$set(row, 'productInfo', res.data || res)
                    // 显示弹框
                    this.productDialog = true
                } catch (err) {
                    console.error('companyDetail error', err)
                    this.$message.error(err.message || '请求产品详情失败')
                }
            }).catch(() => { })
        },

        async confirmEnable() {
            // 确认开通：调用后端添加产品接口 addcompanyProduct({ company_id, product_ids })
            const row = this.enablingRow
            if (!row) {
                this.productDialog = false
                return
            }
            if (!this.selectedProducts || !this.selectedProducts.length) {
                this.$message.warning('请先选择要开通的产品')
                return
            }
            this.enablingLoading = true
            try {
                const payload = {
                    company_id: row.company_id || row.id,
                    product_ids: this.selectedProducts
                }
                await addcompanyProduct(payload)
                // 假设后端返回成功标识，处理结果
                this.$message.success('开通请求已发送')
                if (this.serverSide) {
                    // 刷新列表以获取最新状态
                    await this.fetchData()
                } else {
                    this.$set(row, 'status', 1)
                    if (row.raw) this.$set(row.raw, 'status', 1)
                    this.$set(row, 'enabledProducts', this.selectedProducts.slice())
                }
            } catch (err) {
                console.error('addcompanyProduct error', err)
                this.$message.error(err.message || '开通产品请求失败')
            } finally {
                this.enablingLoading = false
                this.productDialog = false
                this.enablingRow = null
                this.selectedProducts = []
                this.productList = []
            }
        },
        handleSizeChange(size) {
            this.pager.pageSize = size
            this.pager.page = 1
            this.fetchData()
        },
        handleCurrentChange(page) {
            this.pager.page = page
            this.fetchData()
        }
        ,
        resetCompanyForm() {
            this.companyForm = {
                id: null,
                company_id: '',
                company_name: '',
                status: 1
            }
            if (this.$refs.companyForm) this.$refs.companyForm.clearValidate()
        },
        async submitCompany() {
            // 提交创建或编辑
            this.$refs.companyForm.validate(async valid => {
                if (!valid) return
                this.formLoading = true
                try {
                    const payload = Object.assign({}, this.companyForm)
                    // 如果编辑，保留 id
                    const res = await addcompany(payload)
                    // 简单处理：如果后端返回成功，则刷新数据或更新本地列表
                    this.$message.success('保存成功')
                    this.companyDialog = false
                    // 如果为后端分页，直接重新拉取，否则在本地更新或插入
                    if (this.serverSide) {
                        this.fetchData()
                    } else {
                        if (this.isEditing) {
                            const idx = this.list.findIndex(i => i.id === this.companyForm.id)
                            if (idx !== -1) {
                                this.list.splice(idx, 1, Object.assign({}, this.companyForm, { created_at: dayjs().format('YYYY-MM-DD HH:mm:ss') }))
                            }
                        } else {
                            // 新建：在顶部插入
                            this.list.unshift(Object.assign({}, this.companyForm, { id: (res && res.id) || Date.now(), created_at: dayjs().format('YYYY-MM-DD HH:mm:ss') }))
                            this.total = this.total + 1
                        }
                    }
                } catch (err) {
                    console.error('save company error', err)
                    this.$message.error(err.message || '保存失败')
                } finally {
                    this.formLoading = false
                }
            })
        }
    }
}
</script>

<style scoped>
.page-card {
    margin: 20px 12px
}

.card-header {
    font-weight: 700;
    color: #409EFF
}

.card-body {
    padding: 12px
}

.thumb {
    width: 48px;
    height: 48px;
    object-fit: cover;
    border-radius: 4px;
    border: 1px solid #eee
}

.toolbar {
    margin-bottom: 6px
}

.pagination-wrap {
    display: flex;
    justify-content: flex-end;
    margin-top: 12px
}
</style>
